import axios from 'axios'
const wxApi = {
    /**
     * Api 初始化
     * 
     */
    wxRegister(callback) {
        axios.get("wechat/share?url="+window.location.href, {}, {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            timeout: 10000
        })
        .then((res) => {
            // console.log(res.data)
            let wxConfig = res.data.data;
            // console.log('wxConfig',wxConfig)
            wx.config({
                debug: false,
                appId: wxConfig.appId,
                timestamp: wxConfig.timestamp,
                nonceStr: wxConfig.nonceStr,
                signature: wxConfig.signature,
                jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
            })

            wx.ready((res) => {
                // console.log(res)
                const option={
                    title:"飞游无人机",
                    desc: "送你299元新人启航大礼包，享受畅飞快乐，即刻开启租机体验吧~",      // 描述
                    link: "https://api.feiyouyun.com/dist/#/",      // 链接
                    imgUrl: "http://fydown.vipkh.cn/avatar/b3c638e7e6969ad163ff5e3c49199e40.png"  // 图标
                }
                this.ShareTimeline(option)
                this.ShareAppMessage(option)
                if (callback) {
                    callback()
                }
            })
        })
        .catch((error) => {
            console.log('wxApi error', error)
        })
    },

    /**
     * [updateTimelineShareData 微信分享到朋友圈]
     */
    ShareTimeline(option) {
        wx.onMenuShareTimeline({
            title: option.title,    // 标题
            link: option.link,      // 链接
            imgUrl: option.imgUrl,  // 图标
            success() {
                console.log('timeline success')
            },
            cancel() {
                console.log('timeline cancel')
            }
        })
    },

    /**
     * [ShareAppMessage 微信分享给朋友]
     */
    ShareAppMessage(option) {
        wx.onMenuShareAppMessage( {
            title: option.title,    // 标题
            desc: option.desc,      // 描述
            link: option.link,      // 链接
            imgUrl: option.imgUrl,  // 图标
            success() {
                console.log('appmessage success')
            },
            cancel() {
                console.log('appmessage cancel')
            }
        })
    }
}

export default wxApi


// WEBPACK FOOTER //
// ./src/wx.js